module.exports = __webpack_public_path__ + "img/hitribe_icon.fe243fa1.svg";